import React from "react";
import { Inbox } from "lucide-react";

export const TableWrap = ({ children }) => (
  <div className="bg-white border border-slate-200 rounded-lg shadow-sm overflow-hidden">
    <div className="overflow-x-auto">
      <table className="w-full text-sm">{children}</table>
    </div>
  </div>
);

export const Thead = ({ columns }) => (
  <thead>
    <tr className="bg-slate-50 border-b border-slate-200">
      {columns.map((c) => (
        <th
          key={c}
          className="text-left text-[11px] font-semibold uppercase tracking-wider text-slate-500 px-4 py-3"
        >
          {c}
        </th>
      ))}
    </tr>
  </thead>
);

export const EmptyRow = ({ colSpan, message, testId }) => (
  <tr>
    <td colSpan={colSpan} className="py-16">
      <div data-testid={testId} className="flex flex-col items-center justify-center text-center gap-2">
        <div className="w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center">
          <Inbox className="w-5 h-5 text-slate-400" />
        </div>
        <p className="text-slate-600 font-medium">{message}</p>
      </div>
    </td>
  </tr>
);
